import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-667bf50b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "登録完了", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "マイクロチップ番号", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "品種", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "お名前", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "遺伝子検査ID", -1))

import { useRouter } from "vue-router";
import { useDogStore } from "@/stores/dog";
import { home, male, female } from "ionicons/icons";
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonIcon,
  IonList,
  IonItem,
  IonLabel,
  IonButton,
} from "@ionic/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GeneticIdResultView',
  setup(__props) {

const dog = useDogStore()

const router = useRouter();

const goMcInput = () => {
  dog.$reset();
  router.push({ name: "microchipInput" });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), {
                slot: "end",
                "router-link": "/microchip/input",
                "router-direction": "root"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    color: "primary",
                    size: "large",
                    icon: _unref(home)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("生体管理システム（β）")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_unref(IonList), { id: "result-list" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _hoisted_3,
                        _createElementVNode("p", null, _toDisplayString(_unref(dog).microchipId), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _hoisted_4,
                        _createElementVNode("p", null, _toDisplayString(_unref(dog).animalKind), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _hoisted_5,
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_unref(dog).animalNameSuffix) + " ", 1),
                          (_unref(dog).isMale())
                            ? (_openBlock(), _createBlock(_unref(IonIcon), {
                                key: 0,
                                class: "gender-icon gender-icon-male",
                                icon: _unref(male)
                              }, null, 8, ["icon"]))
                            : (_openBlock(), _createBlock(_unref(IonIcon), {
                                key: 1,
                                class: "gender-icon gender-icon-female",
                                icon: _unref(female)
                              }, null, 8, ["icon"]))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _hoisted_6,
                        _createElementVNode("p", null, _toDisplayString(_unref(dog).geneticId), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonButton), {
              color: "primary",
              size: "large",
              expand: "block",
              onClick: _cache[0] || (_cache[0] = () => goMcInput())
            }, {
              default: _withCtx(() => [
                _createTextVNode("続けて登録する")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})